import { RgLimitsNonParallelPredefinedAmounts } from '../types';

export const rgLimitsNonParallelPredefinedAmounts: RgLimitsNonParallelPredefinedAmounts = {
  eur: {
    wager: 100000,
    'single-bet': 1000
  }
};
